module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-BoldItalic.ea3a31b4.woff2";